import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'
import { DEFAULT_PARAMS } from '../constant'
import {
  convertDataSettingToFilter,
  handelDefaultParamsSetting,
  handelDefaultSetting,
} from '../filterSetting/helper'
import { getFilterDefault } from './thunk'

const initialState = {
  data: {
    portfolioId: [],
    bussinessAgeId: [],
    bussinessSizeId: [],
    excludeId: [],
    industryId: [],
    provinceId: [],
    scoreLevelObj: {},
    currency: 'USD',
  },
  paramsSetting: {},
  loading: false,
  isSaveOnly: false,
  paramsSettingDisableApi: {},
}

const slice = createSlice({
  name: 'common/filterCompany/getFilterDefault',
  initialState,
  reducers: {
    resetStoreSetting: (state) => {
      Object.keys(initialState).forEach((key) => {
        if (key === 'paramsSettingDisableApi') return
        state[key] = initialState[key]
      })
    },
    changeParamsSetting: (state, action) => {
      state.paramsSetting = action.payload
    },
    changeDataSetting: (state, action) => {
      state.data = {
        ...state.data,
        ...convertDataSettingToFilter(action.payload),
      }
    },
    changeDataSettingNoHandle: (state, action) => {
      state.data = action.payload
    },
    saveOnly: (state, action) => {
      state.isSaveOnly = action.payload
    },
    changeParamsSettingDisableApi: (state, action) => {
      state.paramsSettingDisableApi = action.payload
    },
  },
  extraReducers: (builder) => {
    //getFilterDefault
    builder.addCase(getFilterDefault.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getFilterDefault.fulfilled, (state, action) => {
      const { allPortId, response } = action.payload
      state.data = response
        ? handelDefaultSetting(response, allPortId)
        : initialState.data
      state.paramsSetting = response
        ? handelDefaultParamsSetting(response, allPortId)
        : DEFAULT_PARAMS
      state.loading = false
    })
    builder.addCase(getFilterDefault.rejected, (state) => {
      state.loading = false
    })
  },
})

export const selectDataSettingDefault = (state) => state[slice.name].data
export const selectParamsSetting = (state) => state[slice.name].paramsSetting
export const selectIsSave = (state) => state[slice.name].isSaveOnly
export const selectLoadingDefault = (state) => state[slice.name].loading
export const selectParamsSettingDisableApi = (state) =>
  state[slice.name].paramsSettingDisableApi

export const {
  resetStoreSetting,
  changeParamsSetting,
  changeDataSetting,
  changeDataSettingNoHandle,
  saveOnly,
  changeFilterType,
  changeParamsSettingDisableApi,
} = slice.actions

register(slice.name, slice.reducer)
